import React, { useEffect, useState } from "react";
import { BiPlay } from "react-icons/bi";
import { BsBackspace } from "react-icons/bs";
import { useGlobalContext } from "../../hooks/context";
import { disablePointAfter } from "../../utils/disabled";
import digits from "../../data/digits";
import staticBalances from "../../data/staticBalances";
import AddMoreItems from "../../components/button/AddMoreItems";
import PaymentButton from "../../components/button/PaymentButton";

const DynamicDonation = ({ donation }) => {
  const { addSelectedItem, findSelectedItem } = useGlobalContext();
  const [isCustom, setIsCustom] = useState(false);
  const [amount, setAmount] = useState("0.0");
  const { id, title } = donation;

  useEffect(() => {
    if (id) {
      const selectedItem = findSelectedItem(id);
      const { price } = selectedItem;
      setAmount(price ? String(price) : "0.0");
    }
  }, [findSelectedItem, id]);

  const customHandler = () => {
    setAmount("0.0");
    addSelectedHandler(0);
    setIsCustom(!isCustom);
  };

  const balanceHandler = (value) => {
    addSelectedHandler(value);
    setAmount(String(value));
  };

  const digitBalanceHandler = (value) => {
    if (amount === "0.0") {
      addSelectedHandler(value);
      setAmount(String(value));
    } else {
      const tempBalance = `${amount}${value}`;
      addSelectedHandler(tempBalance);
      setAmount(tempBalance);
    }
  };

  const pointHandler = () => {
    setAmount(`${amount}${"."}`);
  };

  const deleteHandler = () => {
    const tempBalances = Array.from(amount);
    tempBalances.pop(); // Remove last element from tempBalances array;
    const updateBalance = tempBalances.join("");
    addSelectedHandler(updateBalance);
    setAmount(updateBalance);
  };

  const addSelectedHandler = (value) => {
    const payload = { id, name: title, price: String(value) };
    addSelectedItem(payload);
  };

  // Conditional Style Here
  const balanceStyle = `grid grid-cols-2 grid-row-2 gap-5 kmd:grid-cols-3 kmd:gap-8  ${
    isCustom ? "opacity-50" : "opacity-100"
  }`;
  const amountStyle = `flex items-center ksm:rounded-[10px] kmd:rounded-[20px] klg:rounded-[40px] ${
    Number(amount) > 0 ? "bg-custom-yellow-400" : "bg-white"
  }`;
  const amountInputStyle = `w-full h-full ksm:rounded-[10px] kmd:rounded-[20px] klg:rounded-[40px] ksm:text-2xl kmd:text-4xl klg:text-7xl font-semibold outline-0 placeholder-black ${
    Number(amount) > 0 ? "bg-custom-yellow-400" : "bg-white"
  }`;
  const digitStyle = `col-span-5 kmd:col-span-4 p-5 text-gray-800 grid grid-cols-3 h-full w-full bg-white mx-auto place-items-center ksm:rounded-[10px] kmd:rounded-[20px] klg:rounded-[40px] klg:p-8 ksm:gap-2.5 kmd:gap-5 klg:gap-10 kmd:h-full ${
    !isCustom ? "opacity-50" : "opacity-100"
  }`;

  return (
    <div className="bg-custom-gray-400 w-full h-auto rounded-25 border border-custom-gray-500 absolute bottom-5">
      <div className="ksm:p-8 kmd:p-10 klg:p-12 grid grid-cols-12 gap-x-10 klg:gap-x-10 ">
        <div className="col-span-7 kmd:col-span-8">
          <div className={balanceStyle}>
            {staticBalances.map((amount) => {
              return (
                <button
                  key={amount}
                  className="` ksm:py-1.5 kmd:py-3 klg:py-6 ksm:text-2xl kmd:text-4xl klg:text-6xl font-medium bg-white rounded-full"
                  disabled={isCustom}
                  onClick={() => balanceHandler(amount)}
                >
                  ${amount}
                </button>
              );
            })}
          </div>
          <div className="mt-5 grid grid-cols-2 ksm:gap-x-5 kmd:mt-8 kmd:gap-x-10 klg:mt-16 klg:gap-x-10">
            <div className={amountStyle}>
              <span className="w-[110px] text-right font-semibold ksm:text-2xl kmd:text-4xl kmd:w-[83px] klg:text-7xl klg:w-[166px]">
                $
              </span>
              <input
                readOnly={true}
                disabled={true}
                value={amount}
                onChange={(e) => balanceHandler(e.target.value)}
                className={amountInputStyle}
                placeholder="0.00"
              />
            </div>
            <div
              className="flex items-center justify-center  bg-custom-dodger-blue-300 ksm:rounded-[10px] kmd:rounded-[20px] klg:rounded-[40px]"
              onClick={customHandler}
            >
              <button className=" ksm:text-[15px] kmd:text-30 klg:text-[50px] font-semibold ">
                Custom Amount
              </button>
              <span className=" text-3xl text-right">
                <BiPlay size={80} />
              </span>
            </div>
            {isNaN(Number(amount)) && (
              <small className="text-red-500 ksm:text-sm kmd:text-md klg:text-lg">
                Please enter a valid number
              </small>
            )}
          </div>
          <div className="grid grid-cols-2 gap-x-5 ksm:mt-5 kmd:mt-8 kmd:gap-x-8 klg:mt-16 klg:gap-x-16">
            <PaymentButton />
            <AddMoreItems />
          </div>
        </div>
        <div className={digitStyle}>
          {digits.map((digit) => (
            <button
              key={digit}
              className="digit-button"
              disabled={!isCustom || disablePointAfter(amount)}
              onClick={() => digitBalanceHandler(digit)}
            >
              {digit}
            </button>
          ))}
          <button
            className="digit-button"
            disabled={!isCustom || disablePointAfter(amount)}
            onClick={() => digitBalanceHandler(0)}
          >
            0
          </button>

          <button
            className="digit-button flex justify-center items-center"
            disabled={amount.split(".").length >= 2 || !isCustom}
            onClick={pointHandler}
          >
            .
          </button>

          <button
            className="digit-button flex justify-center items-center ksm:text-[20px] klg:text-[40px]"
            disabled={!isCustom}
            onClick={deleteHandler}
          >
            <BsBackspace />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DynamicDonation;
